import { useCallback, useEffect } from 'react';
import { Snackbar, Alert, Button } from '@mui/material';
import { useRegisterSW } from 'virtual:pwa-register/react';
import { ColoredChip } from '../../components/common/Tag/ColoredTag';
import { OrbotnikColourVariant } from '../../types/types';

function SW() {
  if (import.meta.env.VITE_SW!=='true') {return;}

  const reloadSW = import.meta.env.VITE_RELOAD_SW

  const {
    offlineReady: [offlineReady, setOfflineReady],
    needRefresh: [needRefresh, setNeedRefresh],
    updateServiceWorker,
  } = useRegisterSW({
    onRegisteredSW(swUrl, r) {
      // eslint-disable-next-line no-console
      console.log(`Service Worker at: ${swUrl}`)
      if (reloadSW === 'true') {
        r && setInterval(() => {
          // eslint-disable-next-line no-console
          console.log('Checking for sw update')
          r.update()
        }, 20000 /* 20s for testing purposes */)
      }
      else {
        // eslint-disable-next-line prefer-template,no-console
        console.log('SW Registered: ' + r)
      }
    },
    onRegisterError(error) {
      // eslint-disable-next-line no-console
      console.log('SW registration error', error)
    },
  })

  // const { offlineReady: [offlineReady, setOfflineReady]
  //       , needRefresh: [needRefresh, setNeedRefresh]
  //       , updateServiceWorker 
  //     } = useRegisterSW();

  const handleReloadClick = () => {
    console.log('fdsafdsfdsafdsfdsafdsa')
    updateServiceWorker(true);
    setNeedRefresh(false);
  };

  const handleClose = () => {
    setOfflineReady(false);
    setNeedRefresh(false);
  };
  let variant: OrbotnikColourVariant = 'red';
  let label = 'error';
  let tooltip="An error has occured syncing the PWA content for offline usage";


  if (offlineReady) {
    variant = 'green';
    label = 'ready';
    tooltip="PWA content ready for offline usage";
  } else if (needRefresh) {
    variant = 'orange';
    label = 'syncing';
    tooltip="syncing the PWA content for offline usage";
  }

  useEffect(() => {
    console.log(offlineReady,needRefresh)
  }, [offlineReady,needRefresh]);
  return (
    <>
      <ColoredChip label={label} variant={variant} size="small" tooltip={tooltip}/> 
       {offlineReady && (
        <Snackbar open={offlineReady} 
            autoHideDuration={4500} 
            onClose={handleClose} 
            anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
            style={{ zIndex: 1500 }}
            >
          <Alert severity="success" onClose={handleClose}>
            App is ready to work offline.
          </Alert>
        </Snackbar>
      )}

      {needRefresh && (
        <Snackbar open={needRefresh} 
          style={{ zIndex: 1500 }}
          anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
        >
          <Alert
            severity="warning"
            
            action={
              <>
                <Button color="inherit" size="small" onClick={handleReloadClick}>
                  Reload
                </Button>
                <Button color="inherit" size="small" onClick={handleClose}>
                  Close
                </Button>
              </>
            }
          >
            New content is available, click on reload button to update.
          </Alert>
        </Snackbar>
      )}
    </>
  );
}

export default SW;
